import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonGrowModule } from '@inyova/grow';
import { InyovaSharedModule } from '@inyova/inyova-shared';
import { TranslateModule } from '@ngx-translate/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromGrow from './grow.reducers';

import { SharedModule } from '@shared/shared.module';

import * as fromComponents from './components';
import { GrowEffects } from './grow-effects';
import { GrowRoutingModule } from './grow-routing.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    GrowRoutingModule,
    TranslateModule,
    FormsModule,
    InyovaSharedModule,
    ReactiveFormsModule,
    EffectsModule.forFeature([GrowEffects]),
    StoreModule.forFeature(fromGrow.GROW_REDUCER_FEATURE_KEY, fromGrow.reducer),
    CommonGrowModule
  ],
  declarations: [...fromComponents.components]
})
export class GrowModule {}
